import { useSearchParams } from 'react-router-dom';

export const useParseNumericQueryParam = (key: string): number | null => {
  const [params] = useSearchParams();
  const param = params.get(key);

  if (param === null) return null;

  const numericParam = +param;

  return isNaN(numericParam) ? null : numericParam;
};
